import { stripUrlQuery } from './analytics';

// First-touch attribution from the landing URL. Only values that are actually
// present are returned, and the referrer loses its query/hash (it can carry
// tokens from other sites or from our own reset/verification pages).
export function firstTouchAttribution(location = window.location, referrer = document.referrer) {
  const params = new URLSearchParams(location?.search || '');
  const attribution = {};
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']) {
    const value = params.get(key);
    if (value) attribution[key] = value;
  }
  const cleanReferrer = stripUrlQuery(referrer || '');
  if (cleanReferrer) attribution.referrer = cleanReferrer;
  if (location?.pathname) attribution.landing_route = location.pathname;
  return attribution;
}
